<template>
  <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 4845 632"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xml:space="preserve"
    xmlns:serif="http://www.serif.com/"
    style="
      fill-rule: evenodd;
      clip-rule: evenodd;
      stroke-linejoin: round;
      stroke-miterlimit: 2;
    "
  >
    <path
      id="tassel-primary-color"
      d="M4842.98,604.61l-19.375,-8.246l-103.75,2.332c-2.725,0.043 -4.967,-2.153 -5.009,-4.927c-0.066,-2.774 2.109,-5.063 4.8,-5.123l104.509,-2.34l18.825,18.304Zm-276.134,-75.464l138.375,12.458c2.709,0.238 4.725,2.689 4.492,5.455c-0.242,2.791 -2.625,4.85 -5.342,4.612l-137.525,-12.39l0,-10.135Zm267.925,-31.044c2.734,-0.077 5,2.093 5.067,4.893c0.075,2.766 -2.075,5.08 -4.8,5.157l-268.192,8.459l0,-10.067l267.925,-8.442Zm8.209,34.209l-91.442,-8.892c-2.7,-0.264 -4.683,-2.715 -4.433,-5.481c0.258,-2.757 2.65,-4.799 5.35,-4.527l90.525,8.799l-0,10.101Zm-0,-75.958l-121.184,-6.995c-2.716,-0.145 -4.816,-2.527 -4.666,-5.302c0.166,-2.757 2.475,-4.91 5.2,-4.757l120.65,6.987l-0,10.067Zm-276.134,1.889l121.575,-7.156c2.692,-0.179 5.025,1.974 5.159,4.722c0.15,2.8 -1.925,5.166 -4.659,5.302l-122.075,7.216l0,-10.084Zm0,-27.801l274.842,-8.782c0.45,-0 0.883,0.042 1.292,0.153l-0,9.769c-0.334,0.077 -0.659,0.145 -1.009,0.145l-275.125,8.782l0,-10.067Zm0,-60.539l276.134,0l-0,10.093l-276.134,-0l0,-10.093Zm268.067,-41.145c2.742,0 4.942,2.264 4.942,5.038c-0,2.791 -2.2,5.055 -4.942,5.055l-155.467,0c-2.708,0 -4.941,-2.264 -4.941,-5.055c-0,-2.774 2.233,-5.038 4.941,-5.038l155.467,0Zm8.067,-31.86l-109.75,-15.675l-166.384,3.106l0,-10.067l166.375,-3.106c0.35,-0.026 0.675,-0.017 1.042,0.034l108.717,15.539l-0,10.169Zm-276.134,-69.636l156.275,-3.157c2.717,-0.051 4.959,2.17 5.025,4.944c0.042,2.758 -2.125,5.081 -4.825,5.123l-156.475,3.132l0,-10.042Zm276.134,-3.446l-112.067,-20.194l-164.067,6.944l0,-10.067l163.909,-6.935c0.425,-0.06 0.9,-0.043 1.366,0.059l110.859,19.964l-0,10.229Zm-276.134,-68.419l276.134,-7.522l-0,10.058l-276.134,7.54l0,-10.076Zm276.134,-15.751l-160.359,-24.211l-115.775,5.217l0,-10.076l115.559,-5.208c0.375,-0.042 0.783,-0.034 1.225,0.026l159.35,24.065l-0,10.187Zm-0,-102.935l-39.217,20.534c-0.792,0.409 -1.667,0.579 -2.508,0.537l-0,0.008l-125.525,-7.055c-2.717,-0.17 -4.8,-2.535 -4.642,-5.293c0.142,-2.791 2.475,-4.91 5.183,-4.757l124.209,6.978l42.5,-22.236l-0,11.284Zm-4842.98,-9.32l19.375,8.255l103.75,-2.34c2.717,-0.043 4.967,2.153 5.008,4.927c0.067,2.774 -2.108,5.063 -4.8,5.123l-104.508,2.34l-18.825,-18.305Zm276.133,75.465l-138.375,-12.458c-2.716,-0.238 -4.725,-2.689 -4.491,-5.455c0.241,-2.791 2.625,-4.851 5.341,-4.612l137.525,12.39l0,10.135Zm-267.925,31.044c-2.733,0.076 -5,-2.094 -5.066,-4.893c-0.075,-2.766 2.075,-5.081 4.791,-5.157l268.2,-8.459l0,10.067l-267.925,8.442Zm-8.208,-34.209l91.442,8.892c2.7,0.264 4.683,2.723 4.433,5.481c-0.258,2.757 -2.65,4.799 -5.35,4.527l-90.525,-8.799l-0,-10.101Zm-0,75.958l121.183,6.995c2.717,0.144 4.809,2.527 4.659,5.301c-0.159,2.758 -2.475,4.911 -5.192,4.757l-120.65,-6.986l-0,-10.067Zm276.133,-1.889l-121.575,7.156c-2.691,0.179 -5.025,-1.974 -5.158,-4.723c-0.15,-2.799 1.925,-5.165 4.658,-5.301l122.075,-7.216l0,10.084Zm0,27.801l-274.841,8.782c-0.45,0 -0.884,-0.042 -1.292,-0.153l-0,-9.769c0.333,-0.077 0.658,-0.145 1.008,-0.145l275.125,-8.782l0,10.067Zm0,60.539l-276.133,-0l-0,-10.093l276.133,0l0,10.093Zm-268.066,41.144c-2.742,0 -4.942,-2.263 -4.942,-5.037c-0,-2.792 2.2,-5.055 4.942,-5.055l155.466,-0c2.709,-0 4.942,2.263 4.942,5.055c-0,2.774 -2.233,5.037 -4.942,5.037l-155.466,0Zm-8.067,31.861l109.75,15.675l166.383,-3.106l0,10.067l-166.375,3.106c-0.35,0.026 -0.675,0.017 -1.041,-0.034l-108.717,-15.539l-0,-10.169Zm276.133,69.636l-156.275,3.157c-2.716,0.051 -4.958,-2.17 -5.025,-4.945c-0.041,-2.757 2.125,-5.08 4.825,-5.122l156.475,-3.132l0,10.042Zm-276.133,3.446l112.067,20.194l164.066,-6.944l0,10.067l-163.908,6.935c-0.425,0.06 -0.9,0.043 -1.367,-0.059l-110.858,-19.964l-0,-10.229Zm276.133,68.419l-276.133,7.531l-0,-10.067l276.133,-7.54l0,10.076Zm-276.133,15.751l160.358,24.211l115.775,-5.217l0,10.076l-115.558,5.208c-0.375,0.042 -0.783,0.034 -1.225,-0.026l-159.35,-24.066l-0,-10.186Zm-0,102.935l39.217,-20.535c0.791,-0.408 1.666,-0.578 2.508,-0.536l-0,-0.008l125.525,7.054c2.708,0.171 4.8,2.536 4.642,5.293c-0.142,2.792 -2.475,4.911 -5.184,4.757l-124.208,-6.978l-42.5,22.236l-0,-11.283Z"
      :style="{
        fill: productColors.secondary_1.value,
        transition: 'all 500ms',
        fillRule: 'nonzero',
      }"
    />
    <path
      id="tassel-secondary-color"
      d="M4566.84,491.314l0,-10.188l267.925,-8.45c2.155,-0.067 4.02,1.272 4.745,3.21l3.464,-0.069l-0,10.068l-276.134,5.429Zm0,-76.25l0,-14.235l80.987,1.598l193.855,-6.195c0.45,0 0.883,0.034 1.292,0.153l-0,9.778c-0.185,0.038 -0.367,0.076 -0.552,0.102l0.552,0.011l-0,10.05l-119.181,-2.351l119.181,6.885l-0,10.067l-121.184,-6.995c-2.716,-0.145 -4.816,-2.528 -4.666,-5.302c0.146,-2.431 1.948,-4.382 4.232,-4.703l-73.38,-1.447l-81.136,2.584Zm0,-146.63l0,-19.6l166.375,-3.123c0.35,-0.017 0.675,0 1.042,0.051l99.555,14.23l-0.955,-7.343l-50.175,-4.375c-2.708,-0.204 -4.725,-2.672 -4.5,-5.429c0.208,-2.782 2.617,-4.833 5.317,-4.621l54.108,4.715l-0,0.008c2.283,0.188 4.2,1.983 4.492,4.349l0.875,6.714l-0,17.46l-6.089,-0.87l-270.045,-2.166Zm195.513,-8.484l-29.129,-4.163l-146.453,2.741l175.582,1.422Zm-195.513,-70.095l0,-14.783l113.959,-4.84c-0.31,-0.636 -0.494,-1.351 -0.517,-2.111c-0.083,-2.757 2.075,-5.072 4.783,-5.157l157.909,-4.561l-0,39.985l-5.193,-0.935l-270.941,-7.598Zm204.705,-4.332l-40.638,-7.32l-88.003,3.716l128.641,3.604Zm-22.745,-14.337l89.998,16.221l3.842,0.108l0,-19.045l-93.84,2.716Zm19.79,-140.659l-64,13.07c-0.25,0.051 -0.508,0.094 -0.775,0.094l-136.975,14.926l0,-5.157l-38.933,0c0.7,-0.553 1.542,-0.902 2.467,-0.996l172.391,-18.781l26.325,-5.376l-53.358,-2.999c-2.725,-0.17 -4.808,-2.519 -4.642,-5.31c0.142,-2.774 2.467,-4.893 5.175,-4.748l91.546,5.149l59.337,-12.119l15.826,-8.28l-0,15.336l-12.688,2.592l-26.529,13.89c-0.792,0.409 -1.667,0.579 -2.508,0.536l-0,0.009l-32.659,-1.836Zm-20.421,69.368l-65.554,-9.904l-115.775,5.225l0,-10.067l97.367,-4.395c-0.805,-0.953 -1.265,-2.213 -1.2,-3.569c0.167,-2.765 2.483,-4.91 5.192,-4.774l174.775,10.178l-0,10.084l-122.22,-7.101l93.128,14.06l29.092,-0.117l-0,14.703l-30.058,-4.541l-246.076,0.986l0,-10.042l181.329,-0.726Zm90.509,477.461l-271.838,-3.242l0,-10.05l148.593,1.777c0.818,-1.531 2.395,-2.587 4.207,-2.621l104.509,-2.34l6.519,6.339l12.306,0.147l-0,10.041l-1.85,-0.022l1.85,1.799l-4.296,-1.828Zm-230.831,-232.863l-41.007,-2.56l0,-10.084l202.777,12.644l50.133,-0l23.224,-23.715l-0,14.271l-9.252,9.444l9.252,-0l-0,10.084l-19.131,-0l-1.561,1.593l-0.025,-0c-0.942,0.979 -2.3,1.557 -3.758,1.472l-49.105,-3.065l-202.554,-0l0,-10.084l41.007,-0Zm67.004,-37.986l-108.011,-1.481l0,-10.033l234.717,3.191c2.742,0.043 4.908,2.332 4.883,5.106c0,0.014 -0,0.027 -0.001,0.041l28.468,0c2.742,0 4.942,2.255 4.942,5.046c-0,2.783 -2.2,5.038 -4.942,5.038l-155.467,0c-2.708,0 -4.941,-2.255 -4.941,-5.038c-0,-0.661 0.125,-1.292 0.352,-1.87Zm168.123,317.44l-92.767,-12.356c-2.692,-0.349 -4.592,-2.876 -4.242,-5.616c0.342,-2.766 2.825,-4.698 5.517,-4.366l91.492,12.203l-0,10.135Zm-0,-71.456l-146.417,-5.532c-2.733,-0.102 -4.867,-2.425 -4.767,-5.199c0.1,-2.783 2.392,-4.953 5.1,-4.868l146.084,5.549l-0,10.05Zm-276.134,-412.01l160.95,-1.03c2.725,-0.025 4.934,2.222 4.959,5.021c-0,2.774 -2.2,5.029 -4.909,5.038l-161,1.03l0,-10.059Zm0,363.238l138.375,12.459c2.709,0.246 4.725,2.689 4.492,5.454c-0.242,2.792 -2.625,4.842 -5.342,4.613l-137.525,-12.391l0,-10.135Zm276.134,3.166l-91.442,-8.901c-2.7,-0.264 -4.683,-2.706 -4.433,-5.464c0.258,-2.757 2.65,-4.808 5.35,-4.535l90.525,8.79l-0,10.11Zm-276.134,-74.069l121.575,-7.182c2.692,-0.154 5.025,1.982 5.159,4.748c0.15,2.783 -1.925,5.166 -4.659,5.302l-122.075,7.216l0,-10.084Zm0,-230.998l156.275,-3.14c2.717,-0.043 4.959,2.161 5.025,4.944c0.042,2.766 -2.125,5.055 -4.825,5.114l-156.475,3.149l0,-10.067Zm0,-71.848l276.134,-7.523l-0,10.059l-276.134,7.539l0,-10.075Zm-4563.38,26.144l-3.463,0.069l0,-10.068l276.133,-5.429l0,10.188l-267.925,8.45c-2.154,0.067 -4.019,-1.272 -4.745,-3.21Zm115.718,61.911l-119.181,-6.885l0,-10.067l121.183,6.995c2.717,0.145 4.809,2.528 4.659,5.302c-0.14,2.431 -1.946,4.382 -4.227,4.703l73.267,1.445l81.251,-2.591l0,14.244l-80.986,-1.598l-193.855,6.195c-0.45,-0 -0.884,-0.034 -1.292,-0.153l0,-9.778c0.184,-0.038 0.366,-0.076 0.551,-0.102l-0.551,-0.011l0,-10.05l119.181,2.351Zm-119.181,159.965l0,-17.46l6.088,0.87l270.045,2.166l0,19.6l-166.375,3.123c-0.35,0.017 -0.675,-0 -1.041,-0.051l-99.556,-14.23l0.956,7.343l50.175,4.375c2.708,0.204 4.725,2.672 4.5,5.429c-0.209,2.782 -2.617,4.833 -5.317,4.621l-54.108,-4.715l-0,-0.008c-2.284,-0.188 -4.2,-1.983 -4.492,-4.349l-0.875,-6.714Zm256.203,-4.518l-175.583,-1.422l29.13,4.163l146.453,-2.741Zm-256.203,100.125l0,-39.985l5.193,0.935l270.94,7.598l0,14.783l-113.96,4.84c0.311,0.636 0.496,1.351 0.519,2.111c0.083,2.757 -2.075,5.072 -4.784,5.157l-157.908,4.561Zm94.198,-12.779l-90.022,-16.225l-3.843,-0.108l0,19.045l93.865,-2.712Zm105.872,-10.737l-128.641,-3.604l40.638,7.32l88.003,-3.716Zm-200.07,181.919l0,-15.336l12.688,-2.592l26.529,-13.89c0.791,-0.409 1.666,-0.579 2.508,-0.536l0,-0.009l32.659,1.836l63.999,-13.07c0.25,-0.051 0.509,-0.094 0.775,-0.094l136.975,-14.926l0,5.157l38.934,-0c-0.709,0.553 -1.542,0.902 -2.467,0.996l-172.392,18.781l-26.318,5.376l53.352,2.999c2.716,0.17 4.808,2.519 4.641,5.31c-0.141,2.774 -2.466,4.893 -5.175,4.748l-91.53,-5.148l-59.376,12.13l-15.802,8.268Zm0,-99.515l0,-14.703l30.058,4.541l246.075,-0.986l0,10.042l-181.328,0.726l65.553,9.904l115.775,-5.225l0,10.067l-97.366,4.395c0.805,0.953 1.265,2.213 1.2,3.569c-0.167,2.765 -2.484,4.91 -5.192,4.774l-174.775,-10.178l0,-10.084l122.219,7.101l-93.128,-14.06l-29.091,0.117Zm1.85,-477.87l-1.85,-1.799l4.291,1.828l271.842,3.242l0,10.05l-148.593,-1.777c-0.817,1.531 -2.395,2.587 -4.207,2.621l-104.508,2.34l-6.519,-6.339l-12.306,-0.147l0,-10.041l1.85,0.022Zm7.402,232.892l-9.252,0l0,-10.084l19.131,0l1.561,-1.593l0.025,0c0.941,-0.979 2.3,-1.557 3.758,-1.472l49.105,3.065l202.553,0l0,10.084l-41.007,0l41.007,2.56l0,10.084l-202.776,-12.644l-50.133,0l-23.224,23.724l0,-14.28l9.252,-9.444Zm27.282,41.162l-28.467,-0c-2.742,-0 -4.942,-2.255 -4.942,-5.046c0,-2.783 2.2,-5.038 4.942,-5.038l155.466,-0c2.709,-0 4.942,2.255 4.942,5.038c0,0.661 -0.125,1.292 -0.353,1.87l108.011,1.481l0,10.033l-234.716,-3.191c-2.742,-0.043 -4.909,-2.332 -4.884,-5.106c0.001,-0.014 0.001,-0.027 0.001,-0.041Zm-36.534,-320.616l92.767,12.356c2.691,0.357 4.591,2.876 4.241,5.616c-0.341,2.775 -2.825,4.698 -5.516,4.366l-91.492,-12.203l0,-10.135Zm0,71.456l146.408,5.532c2.742,0.102 4.875,2.425 4.767,5.199c-0.092,2.783 -2.383,4.953 -5.1,4.868l-146.075,-5.549l0,-10.05Zm276.133,412.01l-160.95,1.03c-2.733,0.025 -4.933,-2.222 -4.958,-5.021c0,-2.774 2.2,-5.029 4.908,-5.038l161,-1.03l0,10.059Zm0,-363.238l-138.375,-12.459c-2.716,-0.246 -4.725,-2.689 -4.491,-5.454c0.241,-2.792 2.625,-4.842 5.341,-4.613l137.525,12.391l0,10.135Zm-276.133,-3.166l91.442,8.901c2.7,0.264 4.683,2.706 4.433,5.464c-0.258,2.765 -2.65,4.808 -5.35,4.535l-90.525,-8.79l0,-10.11Zm276.133,74.069l-121.575,7.182c-2.691,0.154 -5.025,-1.982 -5.158,-4.748c-0.15,-2.783 1.925,-5.166 4.658,-5.302l122.075,-7.216l0,10.084Zm0,230.998l-156.275,3.14c-2.716,0.043 -4.958,-2.161 -5.025,-4.944c-0.041,-2.766 2.125,-5.055 4.825,-5.114l156.475,-3.149l0,10.067Zm0,71.848l-276.133,7.523l0,-10.059l276.133,-7.539l0,10.075Z"
      :style="{
        fill: productColors.secondary_2.value,
        transition: 'all 500ms',
        fillRule: 'nonzero',
      }"
    />
    <rect
      id="scarf-primary-color"
      x="270.796"
      y="52.354"
      width="4312.07"
      height="527.291"
      :style="{
        fill: productColors.primary_1.value,
        transition: 'all 500ms',
        stroke: '#373737',
        strokeWidth: '2',
      }"
    />
    <path
      id="scarf-secondary-color"
      d="M1371.63,55.716l0,519.624l-299.267,-0l0,-519.624l299.267,-0Zm800.058,-0l0,519.624l-299.266,-0l-0,-519.624l299.266,-0Zm800.059,-0l-0,519.624l-299.267,-0l0,-519.624l299.267,-0Zm800.05,-0l-0,519.624l-299.267,-0l0,-519.624l299.267,-0Z"
      :style="{
        fill: productColors.primary_2.value,
        transition: 'all 500ms',
        fillRule: 'nonzero',
      }"
    />
    <clipPath xmlns="http://www.w3.org/2000/svg" id="_clip1">
      <rect
        id="text-mask-1"
        x="1072.36"
        y="55.716"
        width="298.963"
        height="519.624"
        style="fill: none"
      />
    </clipPath>
    <g xmlns="http://www.w3.org/2000/svg" clip-path="url(#_clip1)">
      <g id="text-mask-1" serif:id="text-mask-1">
        <g transform="matrix(5.38513e-17,1,-1,8.0978e-17,7281.83,-25596.3)">
          <g transform="matrix(133.333,0,0,133.333,26153.8,6102.92)"></g>
          <text
            x="25920px"
            y="6090px"
            text-anchor="middle"
            :style="{
              fontSize: `${text.size}px`,
              fill: text.color.value,
              transition: 'all 500ms',
              fontFamily: `${text.font}`,
              transform: `translate(0px, ${text.size / 7}px `,
            }"
          >
            {{ text.message2 }}
          </text>
        </g>
      </g>
    </g>
    <clipPath xmlns="http://www.w3.org/2000/svg" id="_clip2">
      <rect
        id="text-mask-2"
        x="1873.44"
        y="55.716"
        width="297.071"
        height="519.624"
        style="fill: none"
      />
    </clipPath>
    <g xmlns="http://www.w3.org/2000/svg" clip-path="url(#_clip2)">
      <g id="text-mask-2" serif:id="text-mask-2">
        <g transform="matrix(5.38513e-17,1,-1,8.0978e-17,8086.6,-26401.1)">
          <g transform="matrix(133.333,0,0,133.333,26958.5,6102.92)"></g>
          <text
            x="26720px"
            y="6102.92px"
            text-anchor="middle"
            :style="{
              fontSize: `${text.size}px`,
              fill: text.color.value,
              transition: 'all 500ms',
              fontFamily: `${text.font}`,
              transform: `translate(0px, ${text.size / 7}px `,
            }"
          >
            {{ text.message2 }}
          </text>
        </g>
      </g>
    </g>
    <clipPath xmlns="http://www.w3.org/2000/svg" id="_clip3">
      <rect
        id="text-mask-3"
        x="2672.65"
        y="55.716"
        width="297.368"
        height="519.624"
        style="fill: none"
      />
    </clipPath>
    <g xmlns="http://www.w3.org/2000/svg" clip-path="url(#_clip3)">
      <g id="text-mask-3" serif:id="text-mask-3">
        <g transform="matrix(6.60741e-17,-1,1,4.40797e-17,-22191.1,-2601.74)">
          <g transform="matrix(133.333,0,0,133.333,-2681.72,25054.8)"></g>
          <text
            x="-2910px"
            y="25054.8px"
            text-anchor="middle"
            :style="{
              fontSize: `${text.size}px`,
              fill: text.color.value,
              transition: 'all 500ms',
              fontFamily: `${text.font}`,
              transform: `translate(0px, ${text.size / 7}px `,
            }"
          >
            {{ text.message }}
          </text>
        </g>
      </g>
    </g>
    <clipPath xmlns="http://www.w3.org/2000/svg" id="_clip4">
      <rect
        id="text-mask-4"
        x="3470.43"
        y="55.716"
        width="301.361"
        height="519.624"
        style="fill: none"
      />
    </clipPath>
    <g xmlns="http://www.w3.org/2000/svg" clip-path="url(#_clip4)">
      <g id="text-mask-4" serif:id="text-mask-4">
        <g transform="matrix(6.60741e-17,-1,1,4.40797e-17,-21386.3,-1796.97)">
          <g transform="matrix(133.333,0,0,133.333,-1876.95,25054.8)"></g>
          <text
            x="-2110px"
            y="25054.8px"
            text-anchor="middle"
            :style="{
              fontSize: `${text.size}px`,
              fill: text.color.value,
              transition: 'all 500ms',
              fontFamily: `${text.font}`,
              transform: `translate(0px, ${text.size / 7}px `,
            }"
          >
            {{ text.message }}
          </text>
        </g>
      </g>
    </g>
    <image
      x="2%"
      y="-145%"
      height="450"
      width="450"
      :href="logo.path"
      id="embdedLogo_1"
      style="transform: rotate(90deg)"
    />
    <image
      x="-11.5%"
      y="625%"
      :href="logo.path"
      height="450"
      width="450"
      id="embdedLogo_2"
      style="transform: rotate(270deg)"
    />
    <defs>
      <svg:style>
        {{ fontFace }}
      </svg:style>
    </defs>
  </svg>
</template>

<script>
import { getFontFace } from "@/assets/fonts/fontsBase64";
import { computed } from "vue";
export default {
  name: "Scarf_2",
  props: ["productColors", "logo", "text"],
  setup(props) {
    const fontFace = computed(() => getFontFace(props.text.font));
    return {
      fontFace,
    };
  },
};
</script>
